module.exports = __webpack_public_path__ + "static/media/bombas-pe-01.6ed97e6b.png";